export const contactInfo = {
    phoneNumber: '+385 91 982 3880',
    emailAddress: 'support@authland.com',
    experiences: 'experiences@authland.com',
};
